import { render } from "./InvitationTokenTemplate.vue?vue&type=template&id=3d13c018&scoped=true"
import script from "./InvitationTokenTemplate.vue?vue&type=script&lang=js"
export * from "./InvitationTokenTemplate.vue?vue&type=script&lang=js"

import "./InvitationTokenTemplate.vue?vue&type=style&index=0&id=3d13c018&lang=less&scoped=true"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d13c018"]])

export default __exports__